module.exports = "https://cdn.thelire.com/ins/resource/lh_login_title.5a0bd5da09d01ae18aa2668da4c005b8.png";